import { render } from "./SocialAdsCard.vue?vue&type=template&id=9ca625dc&scoped=true"
import script from "./SocialAdsCard.vue?vue&type=script&lang=js"
export * from "./SocialAdsCard.vue?vue&type=script&lang=js"

import "./socialAdsCartStyle.scss?vue&type=style&index=0&id=9ca625dc&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ca625dc"]])

export default __exports__